import React, { useState } from "react";
import { Typography, Card, FormControlLabel, Stack } from "@mui/material";
import IOSSwitch from "./IOSSwitch";
import { useAuth } from "../../context/API_Client";
import { useEffect } from "react";
import { colorBrandObject } from "../../../constants/brandings";
import { readableColor } from "polished";

const MoreOption = ({ disabledOptions, updateDisabledOptions }) => {
  const optionsArray = [
    "SHIPPING_ADDRESS",
    "BILLING_ADDRESS",
    "ORDER_ITEM_DETAILS",
    "MERCHANT_LOGO",
    "TIMER",
  ];
  const displayOptionsArray = [
    "Edit Shipping Address",
    "Edit Billing Address",
    "Order Item Details",
    "Logo",
    "Expiry Timer",
  ];
  const [shipping, setShipping] = useState(true);
  const [billing, setBilling] = useState(true);
  const [personal, setPersonal] = useState(true);
  const [order, setOrder] = useState(true);
  const [logo, setLogo] = useState(true);
  const [expiry, setExpiry] = useState(true);

  const checkedList = [shipping, billing, personal, order, logo, expiry];

  useEffect(() => {
    if (disabledOptions?.find((ele) => ele === optionsArray[0])) {
      setShipping(false);
    } else {
      setShipping(true);
    }
    if (disabledOptions?.find((ele) => ele === optionsArray[1])) {
      setBilling(false);
    } else {
      setBilling(true);
    }
    if (disabledOptions?.find((ele) => ele === optionsArray[2])) {
      setPersonal(false);
    } else {
      setPersonal(true);
    }
    if (disabledOptions?.find((ele) => ele === optionsArray[3])) {
      setOrder(false);
    } else {
      setOrder(true);
    }
    if (disabledOptions?.find((ele) => ele === optionsArray[4])) {
      setLogo(false);
    } else {
      setLogo(true);
    }
    if (disabledOptions?.find((ele) => ele === optionsArray[5])) {
      setExpiry(false);
    } else {
      setExpiry(true);
    }
  }, [disabledOptions]);

  const handleChange = (id, index) => {
    if (index == 0) updateDisabledOptions(!shipping, optionsArray[0]);
    if (index == 1) updateDisabledOptions(!billing, optionsArray[1]);
    if (index == 2) updateDisabledOptions(!personal, optionsArray[2]);
    if (index == 3) updateDisabledOptions(!order, optionsArray[3]);
    if (index == 4) updateDisabledOptions(!logo, optionsArray[4]);
    if (index == 5) updateDisabledOptions(!expiry, optionsArray[5]);
  };

  return (
    <>
      <Typography
        sx={{
          padding: "30px 0px 0px 0px",
          fontSize: "14px",
          fontWeight: "600",
          color: "#2C2C2C",
          opacity: "0.85",
        }}
      >
        More Options
      </Typography>
      {displayOptionsArray?.map((option, idx) => {
        return (
          <Card
            variant="outlined"
            sx={{
              minWidth: 268,
              minHeight: 68,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingLeft: "0px",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              borderRadius: "0",
            }}
          >
            <Stack
              direction="row"
              spacing={2}
              sx={{
                width: "268px",
                height: "22px",
                padding: "3px 15px 3px -1px",
                justifyContent: "space-between",
                marginTop: "-14px",
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: "400" }}>
                {option}
              </Typography>
              <FormControlLabel
                control={
                  <IOSSwitch
                    onClick={() => handleChange(optionsArray[idx], idx)}
                    checked={checkedList[idx]}
                    sx={{
                      m: 1,
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "white",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                        backgroundColor: colorBrandObject?.secondaryButtonColor,
                      },
                    }}
                  />
                }
              />
            </Stack>
          </Card>
        );
      })}
    </>
  );
};

export default MoreOption;
